// src/components/SettingsMenu.js
import React, {useRef, useEffect, useState} from 'react';
import axios from 'axios';
import {useNavigate} from "react-router-dom";

//axios.defaults.baseURL = process.env.BASEURL

export const SettingsMenu = ({ isSettingsMenuOpen, closeSettingsMenu, buttonRef }) => {
  const menuRef = useRef(null);
  const navigate = useNavigate();
  const [Berende, setBerende] = useState(false)
  const [Admin, setAdmin] = useState(false)

  useEffect(() => {
    const checkAuth = async () => {
      const response = await axios.get('/api/auth/validate-token', { withCredentials: true });
      const user = response.data.user.organization;
      if (user === "admin") {
        setAdmin(true)
      }
      if (response.data.user.isBerende) {
        setBerende(true)
      }
    };

    checkAuth();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target) && !buttonRef.current.contains(event.target)) {
        closeSettingsMenu();
      }
    };

    if (isSettingsMenuOpen) {
      document.addEventListener('mousedown', handleClickOutside);
    } else {
      document.removeEventListener('mousedown', handleClickOutside);
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [isSettingsMenuOpen, closeSettingsMenu]);

  const handleLogout = async () => {
    try {
      const response = await axios.post('/api/auth/logout', { withCredentials: true });
      if (response.status === 200) {
        console.log(response.data.message);
        window.location.href = '/signin';
      }
    } catch (error) {
      console.error('Error during logout:', error);
    }
  };

  const handleHome = async () => {
    closeSettingsMenu();
    navigate(`/`);
  };

  const handleMachines = async () => {
    closeSettingsMenu();
    navigate(`/machine/`);
  };

  const handleBerende = async () => {
    closeSettingsMenu();
    navigate(`/lmb-logging/`);
  };

  const handleOrganizations = async () => {
    closeSettingsMenu();
    navigate(`/organization/`);
  };

  const handleUsers = async () => {
    closeSettingsMenu();
    navigate(`/Users/`);
  };

  const handleApi = async () => {
    closeSettingsMenu();
    navigate(`/Api/`);
  };

  return (
    <div ref={menuRef} className={`fixed top-12 left-0 bg-gray-100 shadow-lg w-72 bottom-0 p-1 transform transition-transform ${isSettingsMenuOpen ? 'scale-100 opacity-100' : 'scale-95 opacity-0 pointer-events-none'}`}>
      <ul className="p-2 flex gap-2 *:p-4 *:gap-3 *:flex *:bg-white *:text-xl *:shadow *:rounded-md flex-col">
        <li onClick={handleHome} className="cursor-pointer text-gray-700 hover:text-orange-500 flex font-medium"><img className={"w-8 h-8"} src={"/menu_icons/home.svg"} alt={""}/>Home</li>

        {!Berende ? <li onClick={handleMachines} className="cursor-pointer text-gray-700 hover:text-orange-500 font-medium"><img className={"w-8 h-8"} src={"/menu_icons/machines.svg"} alt={""}/>Machines</li> : ""}

        {Berende || Admin ? <li onClick={handleBerende} className="cursor-pointer text-gray-700 hover:text-orange-500 font-medium"><img className={"w-8 h-8"} src={"/menu_icons/machines.svg"} alt={""}/>{Admin ? "LMB Logging" : "Machines"}</li> : ""}

        <li onClick={handleOrganizations} className="cursor-pointer text-gray-700 hover:text-orange-500 flex font-medium"><img className={"w-8 h-8"} src={"/menu_icons/key.svg"} alt={""}/>Organisatie Codes</li>

        {Admin ? <li onClick={handleUsers} className="cursor-pointer text-gray-700 hover:text-orange-500 font-medium"><img className={"w-8 h-8"} src={"/menu_icons/account.svg"} alt={""}/>Gebruikers</li> : ""}

        {Admin ? <li onClick={handleApi} className="cursor-pointer text-gray-700 hover:text-orange-500 font-medium"><img className={"w-8 h-8"} src={"/menu_icons/key.svg"} alt={""}/>Api Keys</li> : ""}

        <li onClick={handleLogout} className="bottom-3 absolute w-11/12 cursor-pointer text-gray-700 hover:text-orange-500 font-medium border-none"><img className={"w-8 h-8"} src={"/menu_icons/log-out.svg"} alt={""}/>Logout</li>
      </ul>
    </div>
  );
};
